import { RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';
import { CAI } from '../../shared/routes/cai-routes.model';

const configureRoutes = (routes: RoutesService) => () => {
  routes.add([
    {
      path: 'integrations/channels',
      iconClass: 'fa-solid fa-shapes',
      name: '::Menu:ChannelIntegrations',
      parentName: '::Menu:Integrations',
      order: 1,
      requiredPolicy: 'Designer.ChannelIntegrations',
    } as CAI.Route,
    {
      path: 'integrations/services',
      iconClass: 'fa-solid fa-link',
      name: '::Menu:ServiceIntegrations',
      parentName: '::Menu:Integrations',
      order: 2,
      requiredPolicy: 'Designer.ServiceIntegrations',
    } as CAI.Route,
    {
      path: 'integrations/llm-configurations',
      iconClass: 'fa-solid fa-head-side-gear',
      name: '::Menu:LlmConfigurations',
      parentName: '::Menu:Integrations',
      order: 3,
      requiredPolicy: 'Designer.LlmConfigurations',
    } as CAI.Route,
    {
      path: 'integrations/mcp-servers',
      iconSvg: 'assets/images/mcp.svg',
      name: '::Menu:McpServers',
      parentName: '::Menu:Integrations',
      order: 4,
      requiredPolicy: 'Designer.McpServers',
    } as CAI.Route,
  ]);
};

export const INTEGRATIONS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];
